module.exports = __webpack_public_path__ + "static/media/button_rindab19999a37acd186603013c511cbc81.webp";